import { Spinner } from '../../../components/spinner/spinner';
import { NavLink } from 'react-router-dom';
import Icon from '../../../components/icons/icon';
import { Typography } from '../../../components/typography/typography';
import { Dropdown } from '../../../components/dropdown/dropdown';
import { Button } from '../../../components/form/button';
import { useEffect, useState } from 'react';
import { ScheduledReport } from '../../../clients/quipli-service/report/report';
import { toast } from '../../../util/toasts';
import { useReportApiV2 } from '../../../clients/quipli-service/report/report-api-v2';
import { DataTable, DataTableRow } from '../../../components/table/data-table';
import { QuipliLink } from '../../../components/link/quipli-link';

export const ReportSchedule = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true),
    [scheduledReports, setScheduledReports] = useState<ScheduledReport[]>([]),
    [data, setData] = useState<DataTableRow[]>([]);

  const { listScheduledReports } = useReportApiV2();
  const load = async () => {
    setIsLoading(true);
    try {
      console.log('Fetching');
      const _sreports = await listScheduledReports();
      console.log(_sreports);
      setScheduledReports(_sreports);
      setData(_sreports.map(buildDataRow));
    } catch (e: any) {
      console.error(`Error loading reports ${e}`);
      toast('Error loading reports', 'error');
    } finally {
      setIsLoading(false);
    }
  };

  const buildDataRow = (report: ScheduledReport): DataTableRow => {
    return {
      mobileHeader: (
        <>
          <div>
            <NavLink to={`/manager/reports/dailySchedule/${report.id}`}>{report.report.name}</NavLink>
          </div>
        </>
      ),
      fields: {
        reportName: report.report.name,
      },
      className: 'cursor-pointer',
      redirectTo: `reports/dailySchedule/${report.id}`,
    };
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <div className={'container-v2'}>
      <div className="flex justify-between items-center">
        <Typography type="display-sm" weight={'medium'}>
          Scheduled Reports
        </Typography>
        <div className="">
          <Dropdown
            trigger={() => (
              <Button className="button-tertiary">
                <Icon icon="DotsVertical" />
              </Button>
            )}
          >
            <QuipliLink className="block md:hidden" to="reports/dailySchedule/create">
              Add Scheduled Report
            </QuipliLink>
          </Dropdown>
        </div>
      </div>
      {isLoading || scheduledReports === undefined ? (
        <Spinner />
      ) : (
        <DataTable isLoading={isLoading} columnNames={[{ key: 'reportName', label: 'Report Name' }]} data={data} />
      )}
    </div>
  );
};
